import React, { useState } from 'react';
import CuentaCard from './CuentaCard'; // Asegúrate que la ruta sea correcta

const AddCuentasCliente = ({ onAgregarCuenta, listaCuentas = [], onEliminarCuenta }) => {
  const [formData, setFormData] = useState({
    plataforma: '',
    usuario: '',
    contrasena: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onAgregarCuenta) {
      onAgregarCuenta(formData);
    }
    setFormData({ plataforma: '', usuario: '', contrasena: '' });
  };

  return (
    <div className="w-full p-6 bg-white rounded-lg shadow-md space-y-8">
      
      {/* Sección del Formulario Horizontal (Sin cambios) */}
      <div>
        <h3 className="text-lg font-semibold text-gray-800 mb-4">Agregar Nueva Cuenta</h3>
        <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-4 gap-4 items-end">
          {/* ... inputs del formulario ... */}
           <div className="md:col-span-1">
            <label htmlFor="plataforma" className="block text-sm font-medium text-gray-700 mb-1">
              Plataforma
            </label>
            <input
              type="text"
              id="plataforma"
              name="plataforma"
              value={formData.plataforma}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>

          <div className="md:col-span-1">
            <label htmlFor="usuario" className="block text-sm font-medium text-gray-700 mb-1">
              Usuario o Correo
            </label>
            <input
              type="text"
              id="usuario"
              name="usuario"
              value={formData.usuario}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>

          <div className="md:col-span-1">
            <label htmlFor="contrasena" className="block text-sm font-medium text-gray-700 mb-1">
              Contraseña
            </label>
            <input
              type="text"
              id="contrasena"
              name="contrasena"
              value={formData.contrasena}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>

          <div className="md:col-span-1">
            <button
              type="submit"
              className="w-full bg-blue-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-blue-700 transition duration-300"
            >
              Agregar
            </button>
          </div>
        </form>
      </div>

      {/* Separador y Sección de Lista de Cuentas */}
      <div className="border-t border-gray-200 pt-6">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">
          Cuentas Existentes ({listaCuentas.length})
        </h3>
        {listaCuentas && listaCuentas.length > 0 ? (
          // VVVVVV  ESTA ES LA LÍNEA MODIFICADA VVVVVV
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
            {listaCuentas.map((cuenta, index) => (
              <CuentaCard 
                key={index} 
                cuenta={cuenta} 
                onEliminar={onEliminarCuenta} 
              />
            ))}
          </div>
        ) : (
          <div className="text-center py-8 bg-gray-50 rounded-lg">
            <p className="text-gray-500">Este cliente aún no tiene cuentas guardadas.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AddCuentasCliente;